// extracted by mini-css-extract-plugin
export default {"panelWrapper":"_1RY-pvho","center":"_8aAw4kOb","withCover":"_11ByDhjE","left":"_264mXBey","right":"_24KWe64d","logoBox":"_3b1tWmHK","content":"_3Ln5B_da"};